import React from "react";
import { useFMenuCard } from "./hooks/useFMenuCard";
import styles from "./style/FMenuCard.module.scss";
/* This example requires Tailwind CSS v2.0+ */
import { ChevronRightIcon } from "@heroicons/react/solid";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const FMenuCard = ({ arrayGroups = [] }) => {
  return (
    <div>
      <ul
        role="list"
        className="mt-3 grid grid-cols-1 gap-5 sm:gap-6 lg:grid-cols-2"
      >
        {arrayGroups.map((group) => (
          <li
            key={group.name}
            className="col-span-1 flex shadow-md rounded-md border-2 cursor-pointer"
            onClick={() => {
              group.onclick();
            }}
          >
            <div
              className={classNames(
                "flex-shrink-0 flex items-center justify-center w-16 text-white text-sm font-medium rounded-l-md border-b-1"
              )}
            >
              <div
                className="border-0 p-2 m-3 rounded-full"
                style={{ backgroundColor: group.iconBackground }}
              >
                <img src={group.img} className="w-10" alt="" />
              </div>
            </div>
            <div className="flex-1 flex items-center justify-between border-gray-200 bg-white rounded-r-md truncate">
              <div className="flex-1 px-4 py-2 text-sm truncate">
                <a className="text-gray-900  hover:text-gray-600 font-bold">
                  {group.title}
                </a>
                <p className="text-gray-500 font-regular">
                  {group.description}
                </p>
              </div>
              <div className="flex-shrink-0 pr-2">
                <button
                  type="button"
                  className="w-8 h-8 bg-white inline-flex items-center justify-center text-gray-400 rounded-full bg-transparent hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                >
                  <span className="sr-only">Open options</span>
                  <ChevronRightIcon className="w-5 h-5" aria-hidden="true" />
                </button>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default FMenuCard;
